import { useEffect, useRef, useState, type ReactNode } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useApp } from '@/shared/app-context';
import { errorMessage } from '@/shared/http/http-client';
import { Skeleton } from '@/shared/ui';
import styles from './auth.module.scss';

/** Cible du lien reçu par email : consomme le jeton puis entre dans l'application. */
export function MagicLinkCallback(): ReactNode {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { api, setMember } = useApp();
  const [error, setError] = useState<string | null>(null);
  // Le jeton est à usage unique : en StrictMode, React monte deux fois en développement
  // et le second appel échouerait sur un lien pourtant valide.
  const consumed = useRef(false);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setError('Ce lien est incomplet.');
      return;
    }
    if (consumed.current) return;
    consumed.current = true;

    api.auth
      .consumeMagicLink(token)
      .then((member) => {
        setMember(member);
        void navigate('/', { replace: true });
      })
      .catch((cause: unknown) => setError(errorMessage(cause)));
  }, [api, navigate, params, setMember]);

  return (
    <div className={styles.gate}>
      <div className={styles.gateInner}>
        {error ? (
          <>
            <h1>Lien inutilisable</h1>
            <p>{error}</p>
            <Link to="/login">Demander un nouveau lien</Link>
          </>
        ) : (
          <>
            <Skeleton />
            <p>Ouverture des portes du chai…</p>
          </>
        )}
      </div>
    </div>
  );
}
